import { Spinner, NonIdealState, Button } from '@blueprintjs/core';
import type { AxiosError } from 'axios';
import axios from 'axios';
import * as React from 'react';
import { connect } from 'react-redux';

import { queryClient } from 'vms/app/queries';
import { usersQuery } from 'vms/features/accounts/queries';
import { DialogProvider } from 'vms/features/dialog/DialogContext';
import { Actions as FlagActions } from 'vms/features/flags/actions';
import {
  loadInspectionCategoriesSuccess,
  loadInspectionTasksSuccess,
} from 'vms/features/inspection/actions';
import { loadLocationsSuccess } from 'vms/features/locations/actions';
import NoteCreator from 'vms/features/notes/NoteCreator';
import {
  vehiclesMetaLoadSuccess,
  loadVehicleInWorkSuccess,
} from 'vms/features/vehicles/actions';

import { main as mainContent, footer as footerSection } from '../AppLayout.css';

import Navbar from './Navbar';
import Sidebar from './Sidebar';

interface Props {
  vehiclesMetaLoadSuccess: typeof vehiclesMetaLoadSuccess;
  loadLocationsSuccess: typeof loadLocationsSuccess;
  loadInspectionCategoriesSuccess: typeof loadInspectionCategoriesSuccess;
  loadInspectionTasksSuccess: typeof loadInspectionTasksSuccess;
  loadVehicleInWorkSuccess: typeof loadVehicleInWorkSuccess;
  loadFlagsSuccess: typeof FlagActions.loadFlagsSuccess;
  children?: React.ReactNode;
}

interface State {
  error: string;
  isOrgDataReceived: boolean;
}

class Base extends React.Component<Props, State> {
  state: State = {
    error: '',
    isOrgDataReceived: false,
  };

  fetchOrgData = () => {
    Promise.all([axios.get('/organization/'), queryClient.fetchQuery(usersQuery)]).then(
      ([response]) => {
        this.props.vehiclesMetaLoadSuccess(response.data.vehicles_meta);
        this.props.loadLocationsSuccess(response.data.locations);
        this.props.loadInspectionCategoriesSuccess(response.data.inspection_categories);
        this.props.loadInspectionTasksSuccess(response.data.inspection_tasks);
        this.props.loadVehicleInWorkSuccess(response.data.vehicle_in_work);
        this.props.loadFlagsSuccess(response.data.flags);
        this.setState({ isOrgDataReceived: true });
      },
      (error: AxiosError) => {
        this.setState({ error: error.message });
      }
    );
  };

  componentDidMount() {
    this.fetchOrgData();
  }

  render() {
    if (!this.state.isOrgDataReceived) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            height: '100vh',
          }}
        >
          {this.state.error ? (
            <NonIdealState
              icon="error"
              title="Error"
              description={this.state.error}
              action={
                <Button
                  text="Try again"
                  icon="refresh"
                  onClick={() => {
                    this.setState({ error: '' });
                    this.fetchOrgData();
                  }}
                />
              }
            />
          ) : (
            <Spinner size={100} />
          )}
        </div>
      );
    }
    return (
      <DialogProvider>
        <Navbar />
        <div style={{ display: 'flex' }}>
          <Sidebar />
          <main className={mainContent}>{this.props.children}</main>
        </div>
        <NoteCreator />
        <footer className={footerSection} />
      </DialogProvider>
    );
  }
}

export default connect(null, {
  vehiclesMetaLoadSuccess,
  loadLocationsSuccess,
  loadInspectionCategoriesSuccess,
  loadInspectionTasksSuccess,
  loadVehicleInWorkSuccess,
  loadFlagsSuccess: FlagActions.loadFlagsSuccess,
})(Base);
